module.exports = __webpack_public_path__ + "img/001整体.2051ea30.png";